<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M38 38V10C38 7.8 36.2 6 34 6H14C11.8 6 10 7.8 10 10V38H6V42H42V38H38ZM34 38H14V10H34V38ZM26 22H30V26H26V22Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
